import React from 'react';
import { Typography } from '@material-ui/core';
import { PlaceholderProps } from 'react-select/src/components/Placeholder';
import { OptionTypeBase } from 'react-select/src/types';

export const Placeholder = (props: PlaceholderProps<OptionTypeBase, boolean>) => {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
      style={{ ...props.innerProps?.style, position: 'absolute' }}
    >
      {props.children}
    </Typography>
  );
};
